import { RouteConfig } from '@typing/global';
import AuthRoutes from './authRoutes';
import { BusinessAdminRoutes } from './bussinessAdminRoutes';
import { GlobalAdminRoutes } from './globalAdminRoutes';
import { ReferrerAdminRoutes } from './referrerAdminRoutes';

// router file
export const Routes: RouteConfig[] = [
    //  here routes will be defined
];

export const AdminRoutes: any[] = [...AuthRoutes, ...BusinessAdminRoutes];
export const ReferrerRoutes: any[] = [...AuthRoutes, ...ReferrerAdminRoutes];
export const SuperAdminRoutes: any[] = [...AuthRoutes, ...GlobalAdminRoutes];
